document.addEventListener('DOMContentLoaded', () => {
	// Listen for the targets to intersect the viewport, at which point we can update the position of the background color in the AccessiBe button as scroll progresses

	const targets = document.querySelectorAll('.section-base.color-dark')
	const button = document.querySelector('#accessibe-trigger')

	// This flag is so we know if there's another section in the viewport already overlapping with the AccessiBe button
	// Because if there is, we don't want to set --bg-position to its default value of 0px
	let overlappingTargets = new Set()
	// To be honest, I really didn't think this would work. But it did. So don't ask me *how* because I don't know.

	const symbol = Symbol()

	const controlScrollListener = (entries, observer) => {
		entries.forEach(entry => {
			if (entry.isIntersecting) {
				if (entry.target[symbol]) {
					// Just in case this wasn't already removed for some reason
					window.removeEventListener('scroll', entry.target[symbol])
				}
				entry.target[symbol] = scrollListener(entry.target)
				// Target entered viewport, attach scroll listener
				window.addEventListener('scroll', entry.target[symbol])
			} else {
				// Target exited, remove scroll listener
				window.removeEventListener('scroll', entry.target[symbol])
				// This is here as well as below because, if the user scrolls super fast,
				// the event listener might be removed before this code executes in the scrollListener function below,
				// leaving the button in a weird half-clipped position
				overlappingTargets.delete(entry.target)
				if (overlappingTargets.size == 0) {
					button.style.setProperty('--bg-position', `0px`)
				}
			}
		})
	}

	// Currying: https://stackoverflow.com/a/45696430
	const scrollListener = function (target) {
		return function doScroll(e) {
			const targetBox = target.getBoundingClientRect()
			const buttonBox = button.getBoundingClientRect()
			// First, check if button is overlapping with this target, or a different target
			const overlapTop = buttonBox.bottom - targetBox.top
			const overlapBottom = targetBox.bottom - buttonBox.top
			const overlapLeft = buttonBox.right - targetBox.left
			const overlapRight = targetBox.right - buttonBox.left
			if (
				overlapTop > 0 &&
				overlapBottom > 0 &&
				overlapLeft > 0 &&
				overlapRight > 0
			) {
				overlappingTargets.add(target)

				let bgPosition = Math.min(overlapTop, buttonBox.height)
				if (overlapBottom < buttonBox.height) {
					bgPosition = bgPosition + buttonBox.height - overlapBottom
				}

				// If overlapping multiple sections, we need to just keep the whole thing filled in
				if (overlappingTargets.size > 1) {
					bgPosition = buttonBox.height
				}

				button.style.setProperty('--bg-position', `${bgPosition * -1}px`)
			} else {
				if (overlappingTargets.size == 0) {
					button.style.setProperty('--bg-position', `0px`)
				}
				overlappingTargets.delete(target)
			}
		}
	}

	if (targets.length > 0 && button) {
		const observer = new IntersectionObserver(controlScrollListener)
		targets.forEach(target => {
			observer.observe(target)
		})
	}
})
